module.exports = __webpack_public_path__ + "resources/img/bg-career-card3@2x.4175e491.jpg";